import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            精彩花絮
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            幕后故事与独家内容，一网打尽
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaData.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer hover:shadow-md transition-shadow duration-300"
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-50/80 text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <i className="ri-play-circle-fill text-2xl"></i>
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}